import { getRequest } from '@/core';
import { tripAddresses } from '@/requests';

export default async function getTripAddressByIdRequest(id) {
	let url = tripAddresses.getByIdPath(id);
	let response = await getRequest(url);
	return response;
}
